import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Content from '../../../../layout/content/Content'
import Head from '../../../../layout/head/Head'
import { getStoreSortItemCategories, updateItemCategoryPositionForStore } from '../../../../redux/admin/store/action';
import { useParams } from 'react-router';
import { ColorRing } from 'react-loader-spinner'
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon } from '../../../../components/Component';
import { Card, Col, Row } from 'antd';
import ToastExample from '../../../../helpers/toast';

function SortItemCategories() {
    const { store_id } = useParams();
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [itemCategories, setItemCategories] = useState([]);
    const [dragItemIndex, setDragItemIndex] = useState();
    const [dragOverItemIndex, setDragOverItemIndex] = useState();
    const dispatch = useDispatch();

    useEffect(() => {
        setLoading(true);
        dispatch(getStoreSortItemCategories(store_id)).then((response) => {
            console.log(response.payload, 'response')
            if (response && response.payload && response.payload.success) {
                setLoading(false);
                setItemCategories(response.payload.categories)
            }
        })
    }, [])

    function handleDragStart(index) {
        return function (event) {
            setDragItemIndex(index)
        }
    };

    const handleDragOver = index => {
        return function (event) {
            event.preventDefault();
        }
    };

    const handleDrop = index => {
        return function move(event) {
            event.preventDefault();
            console.log(`Move Item ${dragItemIndex} To Position: ${index}`);
            const _sports = [...itemCategories];
            const item = _sports.splice(dragItemIndex, 1)[0];
            item.order_column = index;
            _sports.splice(index, 0, item);
            setItemCategories(_sports);
        }
    };

    const updateSortBtn = () => {
        dispatch(updateItemCategoryPositionForStore(itemCategories))
        setShowToast(true);
        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };


    // for the next position
    const handleDragEnter = index => {
        return (event) => {
            setDragOverItemIndex(index);
            console.log("New Position: ", index, event)
        }
    }

    const handleDragLeave = index => {
        return event => {
            setDragOverItemIndex(undefined)
        }
    };

    const handleDragEnd = (event) => {
        setDragItemIndex(undefined);
        setDragOverItemIndex(undefined);
    };

    return (
        <React.Fragment>
            <Head title="Store Item Categories"></Head>
            {loading ?
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
                :
                <React.Fragment>
                    <Head title="Sort Item Categories"></Head>

                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Sort Item Categories
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        {/* <p>You have total {sports.length} stores.</p> */}
                                    </BlockDes>
                                </BlockHeadContent>
                                <BlockHeadContent>
                                    <ToastExample show={showToast} />
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>
                        <Card>
                            <Row>
                                <Col span={24}>
                                    <ui className="no-category-bullets">
                                        {itemCategories.map((itemCategory, index) => (
                                            <li
                                                key={index}
                                                className={dragOverItemIndex === index ? "list-category new-position" : "list-category"}
                                                draggable
                                                onDragStart={handleDragStart(index)}
                                                onDragOver={handleDragOver(index)}
                                                onDrop={handleDrop(index)}
                                                onDragEnter={handleDragEnter(index)}
                                                onDragLeave={handleDragLeave(index)}
                                                onDragEnd={handleDragEnd}
                                            >
                                                <span className='text-left'>  <Icon name="menu" /></span>
                                                <span>{itemCategory.name}</span>
                                            </li>
                                        ))}
                                    </ui>
                                </Col>
                            </Row>
                        </Card>
                        <div className='mt-4 text-right w-100'>
                            <button className='btn btn-lg btn-success' onClick={() => { updateSortBtn() }}>
                                Apply
                            </button>
                        </div>
                    </Content>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default SortItemCategories
